import Dbm from "dbm";

export default class AssetAnimation extends Dbm.core.BaseObject {
    _construct() {
        super._construct();

        this.item.setValue("textures", []);
        this.item.setValue("urls", []);
        this.item.setValue("scaleMode", "nearest");

        this.item.setValue("status", Dbm.loading.LoadingStatus.NOT_STARTED);
    }

    setup(aFilePrefix, aStartIndex, aEndIndex, aFileSuffix = ".png") {

        let urls = [];
        for(let i = aStartIndex; i <= aEndIndex; i++) {
            let paddedI = (i < 10) ? "0" + i : "" + i;
            urls.push(aFilePrefix + paddedI + aFileSuffix);
        }

        this.item.urls = urls;

        return this;
    }

    setSingleImage(aFilePath) {
        this.item.urls = [aFilePath];

        return this;
    }

    setSingleSound(aFilePath) {
        this.item.urls = [aFilePath];

        return this;
    }

    load() {
        if(this.item.status !== Dbm.loading.LoadingStatus.NOT_STARTED) {
            return this;
        }

        this.item.status = Dbm.loading.LoadingStatus.LOADING;
        PIXI.Assets.load(this.item.urls).then(this._callback_loaded.bind(this));

        return this;
    }

    _callback_loaded(aAssets) {
        //console.log("_callback_loaded");
        //console.log(aAssets);

        let scaleMode = this.item.scaleMode;

        let assets = [];
        let currentArray = this.item.urls;
        let currentArrayLength = currentArray.length;
        for(let i = 0; i < currentArrayLength; i++) {
            let texture = aAssets[currentArray[i]];
            if(scaleMode) {
                texture.source.scaleMode = scaleMode;
            }
            assets.push(texture);
        }

        this.item.textures = assets;
        this.item.status = Dbm.loading.LoadingStatus.LOADED;
    }
}